import React, { useEffect, useState } from 'react';
import { Table } from "react-bootstrap";

import { EstRetiroDir } from "../../funciones/EstudiantesFunction";

const RepEstRetirados = (props) => {
    const [estRetirados, setEstRetirados] = useState([]);
    const [preloader, setPreloader] = useState({icon: "fa fa-spinner fa-spin", text: "Cargando listado de estudiantes retirados"});

    useEffect(() => {
        EstRetiroDir((resp) => {
            if (resp.length === 0){
                setPreloader({
                    icon: "fa fa-times",
                    text: "No existen estudiantes retirados"
                })
            }else{
                setEstRetirados(resp);  
            }
            
        })
    }, [props]);

    const styles = {
        padding: 10, fontSize: 12
    }

    let listRetiroEst = () => {
        if(estRetirados.length === 0) return (
            <tr>
                <td colSpan = {3} align = "center"><i className = {preloader.icon}></i> {preloader.text}</td>
            </tr>
        )

        let validaDato = (dato) => {
            if (dato === null) return "";
            return dato
        }

        let status = (data) => {
    
            if(data.status === "2") return (
                <div align = "center">
                    <i className="fa fa-exclamation-triangle text-warning"></i> Pendiente
                </div>
            )
    
            return (
                <div align = "center">
                    <i className="fa fa-check-circle text-success"></i> Procesado
                </div>
            )
        }

        return (
            estRetirados.map(option => (
                <tr key = {option.id}>
                    <td><strong>{`${option.nacionalidad}${option.ci}`}</strong> - <strong className = 'text-danger'>{`${option.apellido_1} ${validaDato(option.apellido_2)} ${option.nombre_1} ${validaDato(option.nombre_2)}`}</strong></td>
                    <td align = "center">{option.fecha}</td>
                    <td align = "center">{status(option.status)}</td>
                </tr>
            )) 
        )
    }

    return (
        <React.Fragment>
            <div className="custom-alert-warning" style={{padding: 5}}>
                <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: "40vh"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color-warning">
                                <td width="80%" style={styles}><strong>Estudiantes</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Status</strong></td>
                            </tr>
                            {listRetiroEst()}
                        </tbody>
                    </Table>
                </div>
            </div>
        </React.Fragment>
    )
}

export default RepEstRetirados;


// WEBPACK FOOTER //
// ./src/views/Reportes/RepEstRetirados.jsx